
import * as React from "react";
import { cn } from "@/lib/utils";
import { Badge, BadgeProps } from "@/components/ui/badge";

// Import the same color mappings used in CustomerTag
const customerColorMap: Record<string, { bg: string, text: string, border: string }> = {
  "Acme Corp": { bg: "bg-indigo-100 dark:bg-indigo-900/50", text: "text-indigo-800 dark:text-indigo-100", border: "border border-transparent dark:border-indigo-800/50" },
  "Global Industries": { bg: "bg-cyan-100 dark:bg-cyan-900/50", text: "text-cyan-800 dark:text-cyan-100", border: "border border-transparent dark:border-cyan-800/50" },
  "Stark Enterprises": { bg: "bg-rose-100 dark:bg-rose-900/50", text: "text-rose-800 dark:text-rose-100", border: "border border-transparent dark:border-rose-800/50" },
  "Wayne Technologies": { bg: "bg-emerald-100 dark:bg-emerald-900/50", text: "text-emerald-800 dark:text-emerald-100", border: "border border-transparent dark:border-emerald-800/50" },
  "Umbrella Corporation": { bg: "bg-fuchsia-100 dark:bg-fuchsia-900/50", text: "text-fuchsia-800 dark:text-fuchsia-100", border: "border border-transparent dark:border-fuchsia-800/50" },
  "Aperture Science": { bg: "bg-blue-100 dark:bg-blue-900/50", text: "text-blue-800 dark:text-blue-100", border: "border border-transparent dark:border-blue-800/50" },
  "Cyberdyne Systems": { bg: "bg-teal-100 dark:bg-teal-900/50", text: "text-teal-800 dark:text-teal-100", border: "border border-transparent dark:border-teal-800/50" },
  "Massive Dynamics": { bg: "bg-purple-100 dark:bg-purple-900/50", text: "text-purple-800 dark:text-purple-100", border: "border border-transparent dark:border-purple-800/50" },
  "Nakatomi Trading": { bg: "bg-lime-100 dark:bg-lime-900/50", text: "text-lime-800 dark:text-lime-100", border: "border border-transparent dark:border-lime-800/50" },
  "Initech Software": { bg: "bg-pink-100 dark:bg-pink-900/50", text: "text-pink-800 dark:text-pink-100", border: "border border-transparent dark:border-pink-800/50" }
};

const getCustomerColor = (customer: string) => {
  if (customerColorMap[customer]) {
    return customerColorMap[customer];
  }
  
  const hash = customer.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0) % 10;
  const colorOptions = Object.values(customerColorMap);
  return colorOptions[hash] || { bg: "bg-slate-100 dark:bg-slate-900/50", text: "text-slate-800 dark:text-slate-100", border: "border border-transparent dark:border-slate-800/50" };
};

interface CustomerBadgeProps extends Omit<BadgeProps, "variant"> {
  customer: string;
}

const CustomerBadge = ({ customer, className, ...props }: CustomerBadgeProps) => {
  if (!customer || customer === 'Not Available') {
    return <Badge variant="outline" className="text-gray-500 bg-transparent" {...props}>Not Available</Badge>;
  }
  
  const { bg, text, border } = getCustomerColor(customer);
  
  return (
    <Badge 
      className={cn(
        "font-medium", 
        bg, 
        text,
        border,
        className
      )} 
      {...props}
    >
      {customer}
    </Badge>
  );
};

export { CustomerBadge };
